export enum EnableGaSteps {
  DOWNLOAD_APP = 'download-app',
  SECURITY_CHECK = 'security-check',
  COMPLETED = 'completed',
}
